/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ws_Saved_PlansInputs */

const en_ws_saved_plans = /** @type {(inputs: Ws_Saved_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved plans`)
};

const id_ws_saved_plans = /** @type {(inputs: Ws_Saved_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana tersimpan`)
};

/**
* | output |
* | --- |
* | "Saved plans" |
*
* @param {Ws_Saved_PlansInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const ws_saved_plans = /** @type {((inputs?: Ws_Saved_PlansInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ws_Saved_PlansInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ws_saved_plans(inputs)
	return en_ws_saved_plans(inputs)
});